import EditUserDetailsDialog from './edit-user-details-dialog.vue'

export {
  EditUserDetailsDialog,
}
